import { AppDispatch, GetAppState, ExtraArgument } from "../store";
import * as inviteSummaryActions from "../slices/inviteSummary";
import { InviteSummary, Error as APIError } from "../../types/apiv1";

export const getInviteSummarys =
  () =>
  async (
    dispatch: AppDispatch,
    getState: GetAppState,
    { api }: ExtraArgument
  ) => {
    const state = getState();

    if (!state.session.authenticated)
      throw new Error("can't get invite summarys when not authenticated");

    dispatch(inviteSummaryActions.pending());

    let response: InviteSummary[];

    try {
      response = await api.organizations.id(state.session.activeOrganization).invites.get();
    } catch (e) {
      switch (e) {
        case APIError.Network:
          dispatch(
            inviteSummaryActions.reset(
              inviteSummaryActions.RejectionReason.Network
            )
          );
          return;
        default:
          dispatch(
            inviteSummaryActions.reset(inviteSummaryActions.RejectionReason.Bug)
          );
          return;
      }
    }

    dispatch(inviteSummaryActions.ready(response));
  };

export const deleteInvite =
  (inviteID: string) =>
  async (
    dispatch: AppDispatch,
    getState: GetAppState,
    { api }: ExtraArgument
  ) => {
    const state = getState();

    if (!state.session.authenticated)
      throw new Error("can't remove invite when not authenticated");

    await api.users.me.invites.id(inviteID).delete();

    dispatch(getInviteSummarys());
  };

export const resendInvitationMail =
  (email: string, org_id: string) =>
  async (
    dispatch: AppDispatch,
    getState: GetAppState,
    { api }: ExtraArgument
  ) => {
    const state = getState();

    if (!state.session.authenticated)
      throw new Error("can't remove request when not authenticated");

    await api.organizations.id(org_id).invites.post(email, "", "", "");

    dispatch(getInviteSummarys());
  };
